import * as Yup from 'yup'

export const vendorProfileSchema = Yup.object({
	profileImg: Yup.string().required('브랜드 로고를 업로드해주세요.'),
	backgroundImg: Yup.string().nullable(true).optional(),
	name: Yup.string().required('브랜드 명을 입력해주세요.'),
	vendorStoreLink: Yup.string()
		.required('사이트 URL을 입력해주세요.')
		.url('유효하지 않은 URl입니다.'),
	companyDescription: Yup.string()
		.required('브랜드 한줄 소개를 작성해주세요.')
		.max(64, '브랜드 한줄 소개는 64자 이내로 작성해주세요.'),
	companyName: Yup.string().required('업체(법인)명을 입력해주세요.'),
	ceoName: Yup.string().required('대표자명을 입력해주세요.'),
	address: Yup.string().required('사업장 소재지를 입력해주세요.'),
	email: Yup.string()
		.required('이메일을 입력해주세요.')
		.matches(
			/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i,
			'이메일 형식이 올바르지 않습니다.',
		),
	phone: Yup.string()
		.required('대표자 연락처를 입력해주세요.')
		.min(8, '연락처는 8자 이상이여야 합니다.')
		.matches(
			/^(0[2-8][0-5]?|01[01346-9]?|(1544|1566|1577|1588|1644|1688))-?(([1-9]{1}[0-9]{2,3})-?([0-9]{4}))?|([0-9]{4})$/,
			'올바른 지역번호 또는 대표번호를 입력해주세요.',
		),
	businessRegistrationNumber: Yup.string().optional(),
	salesReportNumber: Yup.string().optional(),
	vendorContacts: Yup.array().of(
		Yup.object({
			name: Yup.string().required('담당자 명을 입력해주세요.'),
			position: Yup.string().required('당당자 직책을 입력해주세요.'),
			email: Yup.string()
				.required('담당자 이메일을 입력해주세요.')
				.matches(
					/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i,
					'이메일 형식이 올바르지 않습니다.',
				),
			phone: Yup.string()
				.required('담당자 연락처를 입력해주세요.')
				.min(9, '연락처는 9자 이상이여야 합니다.')
				.matches(
					/^(0[2-8][0-5]?|01[01346-9]?|(1544|1566|1577|1588|1644|1688))-?(([1-9]{1}[0-9]{2,3})-?([0-9]{4}))?|([0-9]{4})$/,
					'올바른 지역번호 또는 대표번호를 입력해주세요.',
				),
		}),
	),
})
